import {
  InputBase as MuiInputBase,
  InputBaseProps as MuiInputBaseProps,
} from '@material-ui/core';

export type InputBaseProps = MuiInputBaseProps;

export const InputBase = MuiInputBase;
